import LegalPage from "@/components/LegalPage";
import { BUSINESS } from "@/config/business";

export default function Terms() {
  return (
    <LegalPage title="Terms of Service">
      <p>
        These Terms of Service (&ldquo;Terms&rdquo;) govern your use of{" "}
        {BUSINESS.domain} (the &ldquo;Site&rdquo;) operated by{" "}
        {BUSINESS.legalName} (&ldquo;{BUSINESS.brandName},&rdquo; &ldquo;we,&rdquo;
        or &ldquo;us&rdquo;). By accessing the Site or submitting an inquiry, you
        agree to these Terms. If you do not agree, please do not use the Site.
      </p>

      <h2>1. What we do — and what we are not</h2>
      <p>
        {BUSINESS.brandName} is an advisory and consulting service that helps
        business owners explore consolidation and restructuring options for
        merchant cash advance (MCA) obligations through direct negotiation with
        funders.
      </p>
      <p>
        We are <strong>not</strong> a lender, bank, law firm, or debt settlement
        company. We do not provide loans or extensions of credit, and nothing on
        the Site is an offer of credit or a loan. We do not provide legal,
        financial, tax, or accounting advice.
      </p>

      <h2>2. No guaranteed outcome</h2>
      <p>
        Every business&rsquo;s situation is different. We do not guarantee any
        particular result, savings amount, payment reduction, approval, or
        timeline. Any examples or descriptions of potential outcomes are
        illustrative only and are not a promise of results. Your results depend
        on your circumstances and the decisions of your funders.
      </p>

      <h2>3. Eligibility</h2>
      <p>
        You must be at least 18 years old and authorized to act on behalf of the
        business you are inquiring about. By submitting information, you
        represent that the information you provide is accurate and that you have
        the authority to share it.
      </p>

      <h2>4. Communications consent</h2>
      <p>
        By submitting the assessment form, you consent to be contacted by phone,
        text/SMS, and email as described in our{" "}
        <a href="/privacy">Privacy Policy</a>. Consent is not a condition of any
        purchase, and you may opt out at any time.
      </p>

      <h2>5. Not professional advice</h2>
      <p>
        Content on the Site is provided for general informational purposes only
        and should not be relied upon as legal, financial, tax, or accounting
        advice. You should consult a qualified attorney or advisor before
        entering into, modifying, or terminating any agreement with a funder.
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        The Site and its content, including text, graphics, logos, and design,
        are owned by {BUSINESS.legalName} or its licensors and are protected by
        applicable intellectual property laws. You may not copy, reproduce, or
        distribute the content without our prior written permission.
      </p>

      <h2>7. Third-party services and links</h2>
      <p>
        The Site uses third-party services (such as Jotform for our assessment
        form) and may link to third-party websites. We are not responsible for
        the content, policies, or practices of any third party.
      </p>

      <h2>8. Disclaimer of warranties</h2>
      <p>
        The Site is provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo;
        without warranties of any kind, whether express or implied, including
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement. We do not warrant that the Site will be uninterrupted,
        secure, or error-free.
      </p>

      <h2>9. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {BUSINESS.legalName} and its
        officers, employees, and representatives will not be liable for any
        indirect, incidental, special, consequential, or punitive damages, or
        any loss of profits or revenues, arising out of or related to your use
        of the Site or our services.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless {BUSINESS.legalName} from any
        claims, losses, or expenses arising out of your use of the Site, your
        violation of these Terms, or your violation of any rights of a third
        party.
      </p>

      <h2>11. Governing law</h2>
      <p>
        These Terms are governed by the laws of the State of{" "}
        {BUSINESS.governingState}, without regard to its conflict-of-laws rules.
        Any disputes will be resolved in the courts located in{" "}
        {BUSINESS.governingState}.
      </p>

      <h2>12. Changes to these Terms</h2>
      <p>
        We may update these Terms from time to time. Changes are effective when
        posted, and the &ldquo;Last updated&rdquo; date above reflects the most
        recent revision. Your continued use of the Site constitutes acceptance
        of the updated Terms.
      </p>

      <h2>13. Contact us</h2>
      <p>
        {BUSINESS.legalName}
        <br />
        {BUSINESS.addressLine}, {BUSINESS.cityStateZip}
        <br />
        Email: <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a>
        <br />
        Phone: <a href={BUSINESS.phoneHref}>{BUSINESS.phoneDisplay}</a>
      </p>
    </LegalPage>
  );
}
